module.exports = __webpack_public_path__ + "img/yt.89fc0beb.svg";